<template>
    <div
        :class="[
            'z-textarea',
            {
                'is-focused': isFocused,
                'is-errored': isValid === false,
                'is-valid': isValid,
                'is-filled': textareaValue,
                'is-disabled': disabled,
                'is-resizable': resize
            }
        ]"
    >
        <label class="z-textarea__label">
            <textarea
                class="z-textarea__textarea"
                name="name"
                v-bind="$attrs"
                @blur="onBlur"
                @focus="onFocus"
                @input="onInput($event)"
                @change="onChange($event)"
                v-model="textareaValue"
                :disabled="disabled"
                cols="30"
                rows="4"
            ></textarea>
            <span
                v-show="placeholder"
                v-html="placeholder"
                class="z-textarea__placeholder"
            ></span>
        </label>
        <span :class="['z-textarea__error', errorClass]" v-html="error"></span>
    </div>
</template>

<script>
import { localize } from '@/utils/i18n'

export default {
    name: 'z-textarea',
    model: {
        prop: 'value',
        event: 'input'
    },
    props: {
        placeholder: String,
        value: [Number, String],
        name: {
            type: String,
            required: true
        },
        required: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        resize: {
            type: Boolean,
            default: false
        },
        errorClass: {
            type: String,
            default: ''
        },
        validateOnBlur: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            localValue: null,
            isFocused: false,
            isValid: null,
            error: '',
            text: {
                error: {
                    ru: 'Поле обязательно для заполнения',
                    en: 'Required field'
                }
            }
        }
    },
    computed: {
        textareaValue: {
            get () {
                if (this.value !== undefined) return this.value // для работы без v-model
                return this.localValue
            },
            set (value) {
                this.$emit('input', value)
                this.localValue = value
            }
        }
    },
    methods: {
        onBlur () {
            this.isFocused = false
            if (this.validateOnBlur) this.validate()
        },
        onFocus () {
            this.isFocused = true
        },
        onInput (e) {
            this.$emit('input', e.target.value)
            if (this.isValid !== null) this.$nextTick(this.validate)
        },
        onChange (e) {
            this.$emit('change', e.target.value)
        },
        validate () {
            if (this.required && !(this.textareaValue !== '' && typeof this.textareaValue !== 'object')) {
                this.isValid = false
                this.error = localize(this.text.error)
                return
            }

            this.textareaValue ? this.isValid = true : this.isValid = null
            this.error = ''
        }
    }
}

</script>

<style lang="scss">
$errorColor: #CA3D21;
$validColor: #65BBAA;
$hoverColor: #FFA721;
$focusColor: #A99A6F;

.z-textarea {
    $parent: &;
    font-size: 16px;
    width: 100%;

    &__placeholder {
        padding: 0 4px;
        display: block;
        max-width: 100%;
        position: absolute;
        top: 0.75em;
        left: 16px;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: $token-colors-text-default;
        background-color: transparent;
        pointer-events: none;
        overflow: hidden;
        transform: scale(1);
        transition: all .3s ease-in-out;
        font-size: 1em;
        line-height: 1.5;
  }

    &__label {
        position: relative;
        display: block;
    }

    &__error {
        font-size: 0.8125em;
        color: $errorColor;
        position: relative;
        left: 20px;
    }

    &__textarea {
        resize: none;
        border: 1px solid $token-colors-border-default;
        border-radius: 4px;
        width: 100%;
        box-sizing: border-box;
        padding: $token-spacers-3-xs $token-spacers-2-xs;
        transition: border-color 0.2s ease-in;
    }

    &.is-resizable {
        #{$parent}__textarea {
            resize: vertical;
        }
    }

    // errored state
    &.is-errored {
        #{$parent}__placeholder {
        }

        #{$parent}__textarea {
            border-color: $errorColor;
        }
    }

    // hover state
    &:hover {
        #{$parent}__textarea {
            border-color: $token-colors-border-hover;
        }
    }

    // filled and focused state
    &.is-filled,
    &.is-focused {
        #{$parent}__placeholder {
            width: auto;
            transform: translateY(-16px);
            font-size: 0.75em;
            line-height: 1.2;
            color: $token-colors-border-focus;
            background-color: #fff;
        }

        #{$parent}__textarea {
            border-color: $token-colors-border-focus;
        }
    }

    // valid state
    &.is-valid {
    }
}

</style>
